<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form label-width="7rem"  style="padding: 2rem;width: 30rem">
          <el-form-item label="站点logo" style="width: 30rem">
            <y_upload_img v-model="form.site_logo"></y_upload_img>
          </el-form-item>
          <el-form-item label="登陆页侧边banner" style="width: 30rem">
            <y_upload_img v-model="form.login_banner"></y_upload_img>
          </el-form-item>
          <el-form-item label="登陆页背景图片" style="width: 30rem">
            <y_upload_img v-model="form.login_bg_img"></y_upload_img>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="12">
        <el-form label-width="7rem" style="padding: 2rem;width: 30rem">
          <el-form-item label="底部版权">
            <el-input v-model="form.copyright"></el-input>
          </el-form-item>
          <el-form-item label="icp备案号">
            <el-input v-model="form.icp"></el-input>
          </el-form-item>
          <el-form-item label="登陆窗口标题">
            <el-input v-model="form.login_title"></el-input>
          </el-form-item>
          <el-form-item label="附件大小限制">
            <el-input-number v-model="form.attach_limit_size"></el-input-number>KB
            <el-button @click="form.attach_limit_size = 5120">5M</el-button>
            <el-button @click="form.attach_limit_size = 10240">10M</el-button>
            <div class="y-desc">为0时不限制</div>
          </el-form-item>
          <el-form-item label="附件后缀名限制">
            <el-input autosize v-model="form.attach_limit_ext" type="textarea"></el-input>
            <div class="y-desc">系统支持的文件类型：<br>"image/jpeg", "image/png", "image/gif","video/mpeg4", "video/mp4","audio/mp3", "audio/mpeg"</div>
            <div class="y-desc"><br>  每行一条，为空时系统仅做文件类型校验 示例：</div>
            <div class="y-desc">
              .png <br>
              .jpg <br>
              .mp3 <br>
            </div>
          </el-form-item>
          <el-form-item>
            <el-button @click="submit" type="primary">保存</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>

  </div>
</template>

<script>
import y_upload_img from "@/components/y-form/y-upload/y_upload_img";
export default {
  name: "site",
  components:{
    y_upload_img
  },
  data(){
    return{
      form:{
        copyright:"",
        icp:"",
        site_logo:"",
        login_banner:"",
        login_bg_img:"",
        login_title:"",

        attach_limit_ext:"",
        attach_limit_size:0,
      }
    }
  },
  mounted() {
    this.load();
  },
  methods:{
    load(){
      this.$u.api.founder.systemFetch().then(res=>{
        this.form = res;
      })
    },
    submit(){
      this.$u.api.founder.systemEdit(this.form).then(()=>{
        this.$message.success("操作成功");
      })
    }
  }
}
</script>

<style scoped>

</style>